import { ApplicationMethodTypeId } from '../types';

export enum ConfigureStepActions {
  INITIALIZE = 'initialize',
  RESET = 'reset',
  SET_APPLICATION_METHOD = 'set-application-method',
  SET_DISCOUNT_CODE = 'set-discount-code',
  SET_DISCOUNT_NAME = 'set-discount-name',
  SET_EXTERNAL_ID = 'set-external-id',
  SET_LOYALTY_POINTS_TO_REDEEM = 'set-loyalty-points-to-redeem',
}

type InitializeAction = {
  payload: ConfigureStepState;
  type: ConfigureStepActions.INITIALIZE;
};

type ResetAction = {
  type: ConfigureStepActions.RESET;
};

type SetApplicationMethodAction = {
  payload: ApplicationMethodTypeId;
  type: ConfigureStepActions.SET_APPLICATION_METHOD;
};

type SetDiscountCodeAction = {
  payload: string;
  type: ConfigureStepActions.SET_DISCOUNT_CODE;
};

type SetDiscountNameAction = {
  payload: string;
  type: ConfigureStepActions.SET_DISCOUNT_NAME;
};

type SetExternalIdAction = {
  payload: string;
  type: ConfigureStepActions.SET_EXTERNAL_ID;
};

type SetLoyaltyPointsToRedeem = {
  payload: number | '';
  type: ConfigureStepActions.SET_LOYALTY_POINTS_TO_REDEEM;
};

export type ConfigureStepAction =
  | InitializeAction
  | ResetAction
  | SetApplicationMethodAction
  | SetDiscountCodeAction
  | SetDiscountNameAction
  | SetExternalIdAction
  | SetLoyaltyPointsToRedeem;

export type ConfigureStepState = {
  applicationMethod: ApplicationMethodTypeId;
  discountCode: string;
  discountName: string;
  externalId: string;
  loyaltyPointsToRedeem: number | '';
};

export const configureStepDefaultState: ConfigureStepState = {
  applicationMethod: ApplicationMethodTypeId.Automatically,
  discountCode: '',
  discountName: '',
  externalId: '',
  loyaltyPointsToRedeem: '',
};

export function configureStepReducer(state: ConfigureStepState, action: ConfigureStepAction) {
  switch (action.type) {
    case ConfigureStepActions.INITIALIZE:
      return {
        ...action.payload,
      };
    case ConfigureStepActions.RESET:
      return {
        ...configureStepDefaultState,
      };
    case ConfigureStepActions.SET_APPLICATION_METHOD:
      return {
        ...state,
        applicationMethod: action.payload,
        externalId: '',
      };
    case ConfigureStepActions.SET_DISCOUNT_CODE:
      return {
        ...state,
        discountCode: action.payload,
      };
    case ConfigureStepActions.SET_DISCOUNT_NAME:
      return {
        ...state,
        discountName: action.payload,
      };
    case ConfigureStepActions.SET_EXTERNAL_ID:
      return {
        ...state,
        externalId: action.payload,
      };
    case ConfigureStepActions.SET_LOYALTY_POINTS_TO_REDEEM:
      return {
        ...state,
        loyaltyPointsToRedeem: action.payload,
      };
    default:
      return state;
  }
}
